import React from 'react';

export default function createHeaderColumn(header, key) {
    return (
        <th key={key}>{header}</th>
    );
}


// WEBPACK FOOTER //
// ./src/common/table/createHeaderColumn.js